export const WEEKDAYS = ["S", "M", "T", "W", "T", "F", "S"];
export const WEEKDAY_NAMES = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];
export const MONTHS_SHORT = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];
export const MONTHS_FULL = [
  "JAN",
  "FEB",
  "MAR",
  "APR",
  "MAY",
  "JUN",
  "JUL",
  "AUG",
  "SEPT",
  "OCT",
  "NOV",
  "DEC",
];

export const GOLD = "#F5C518";
export const REF_BG = "#D6C7F0";
export const MG_BG = "#9E9E9E";
export const PR_BG = "#8D6E63";
export const SELF_BG = "#78909C";

export const startOfDay = (value) =>
  new Date(value.getFullYear(), value.getMonth(), value.getDate());

export const addDays = (value, amount) => {
  const next = startOfDay(value);
  next.setDate(next.getDate() + amount);
  return next;
};

export const isSameDay = (a, b) =>
  a &&
  b &&
  a.getFullYear() === b.getFullYear() &&
  a.getMonth() === b.getMonth() &&
  a.getDate() === b.getDate();

export const toDateKey = (value) =>
  `${value.getFullYear()}-${String(value.getMonth() + 1).padStart(2, "0")}-${String(
    value.getDate()
  ).padStart(2, "0")}`;

export const parseTapDateTime = (value) => {
  if (!value) return null;
  const match = String(value).match(
    /^(\d{2})-(\d{2})-(\d{4})(?:\s+(\d{2}):(\d{2}))?/
  );
  if (match) {
    const [, dd, mm, yyyy, hh = "00", min = "00"] = match;
    return new Date(
      Number(yyyy),
      Number(mm) - 1,
      Number(dd),
      Number(hh),
      Number(min)
    );
  }
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const formatTime = (value) => {
  const date = parseTapDateTime(value);
  if (!date) return "--:--";
  return `${String(date.getHours()).padStart(2, "0")}:${String(
    date.getMinutes()
  ).padStart(2, "0")}`;
};

export const formatTime12 = (value) => {
  const date = parseTapDateTime(value);
  if (!date) return "—";
  return date.toLocaleTimeString("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

export const formatMediumDate = (value) => {
  const date = parseTapDateTime(value);
  if (!date) return "—";
  return `${date.getDate()} ${MONTHS_SHORT[date.getMonth()]} ${date.getFullYear()}`;
};

export const formatHeroDate = (value) => {
  const date = parseTapDateTime(value);
  if (!date) return "—";
  return `${String(date.getDate()).padStart(2, "0")} ${MONTHS_SHORT[date.getMonth()]}`;
};

export const formatIsoDate = (value) => {
  const date = parseTapDateTime(value);
  if (!date) return "—";
  return toDateKey(date);
};

export const formatTapDate = (value) => {
  const date = parseTapDateTime(value);
  if (!date) return "—";
  return `${String(date.getDate()).padStart(2, "0")}-${String(
    date.getMonth() + 1
  ).padStart(2, "0")}-${date.getFullYear()}`;
};

export const formatDateLabel = (value, today) => {
  const label = `${value.getDate()} ${MONTHS_SHORT[value.getMonth()]} ${value.getFullYear()} ${
    WEEKDAY_NAMES[value.getDay()]
  }`;
  return isSameDay(value, today) ? `${label} (Today)` : label;
};

export const productTypeCode = (productType) => {
  const value = String(productType || "").toLowerCase();
  if (value.includes("meet")) return "MG";
  if (value.includes("park & ride") || value.includes("park and ride")) return "PR";
  if (value.includes("self")) return "SELF";
  return "OTHER";
};

export const productTypeColor = (code) => {
  if (code === "MG") return MG_BG;
  if (code === "PR") return PR_BG;
  if (code === "SELF") return SELF_BG;
  return "#607D8B";
};

export const terminalNumber = (terminal) => {
  if (!terminal) return "—";
  const match = String(terminal).match(/(\d+)/);
  return match ? match[1] : "—";
};

export const bookingSurname = (name) => {
  if (!name) return "—";
  const cleaned = String(name)
    .replace(/^(mr|mrs|ms|miss|dr|prof)\.?\s+/i, "")
    .trim();
  const parts = cleaned.split(/\s+/);
  return parts[parts.length - 1] || cleaned;
};

export const vehicleLabel = (booking) =>
  [booking?.make, booking?.model].filter(Boolean).join(" ") || "—";

export const isElectricVehicle = (booking) => {
  const text = `${booking?.make || ""} ${booking?.model || ""}`.toLowerCase();
  return /tesla|etron|e-tron|id\.?\s?[345]|ev6|i4|model [3sy]|leaf|ioniq|eqc|eqe|mach-?e|polestar|niro ev/.test(
    text
  );
};

export const getCalendarCells = (viewMonth) => {
  const year = viewMonth.getFullYear();
  const month = viewMonth.getMonth();
  const startWeekday = new Date(year, month, 1).getDay();
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const cells = Array.from({ length: startWeekday }, () => null);
  for (let day = 1; day <= daysInMonth; day += 1) {
    cells.push(new Date(year, month, day));
  }
  return cells;
};

export const groupByProduct = (bookings) => {
  const groups = [];
  bookings.forEach((booking) => {
    const productName = booking.productName || "Other";
    const last = groups[groups.length - 1];
    if (last && last.productName === productName) {
      last.bookings.push(booking);
    } else {
      groups.push({ productName, bookings: [booking] });
    }
  });
  return groups;
};

export const qrImageUrl = (value) =>
  `https://api.qrserver.com/v1/create-qr-code/?size=220x220&margin=4&data=${encodeURIComponent(
    value || ""
  )}`;
